import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const rerunSubjectResultsMutation = gql`
  mutation rerunSubjectResults(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
  ) {
    rerunSubjectResults(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
    )
  }
`

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
}

export type RerunSubjectResultsData = {
  rerunSubjectResults: string | unknown
}

export const useRerunSubjectResultsMutation: WrappedMutation<
  RerunSubjectResultsData,
  MutationVars
> = () =>
  useMutation<RerunSubjectResultsData, MutationVars>(rerunSubjectResultsMutation, {
    client: agentClient,
  })
